<!-- 数据报表首页 -->
<template>
    <div class="dft-container2">
        <!-- 头部Card -->
        <div class="panel-group flex">
            <div v-for="(item, index) in cardData" :key="index">
                <div class=" card-panel flex">
                    <div class="card-panel-icon-wrapper flex">
                        <el-image v-if="item.icon" :src="item.icon" fit="fill" class="icon" />
                    </div>
                    <div class="card-panel-description">
                        <div class="card-panel-num">{{ item.count }}</div>
                        <div class="card-panel-text">
                            {{ item.title }}
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <!-- 商品数据统计 -->
        <div class="card-container">
            <div class="title-container flex">
                <div>
                    <span class="title">商品数据统计</span>
                    <span class="time">更新时间:{{ updateTime }}</span>
                </div>

                <div class="flex" style="align-items: center;">
                    <span style="margin-right: 10px;">日期</span>
                    <el-date-picker v-model="dateTime" type="daterange" range-separator="至" start-placeholder="开始日期"
                        end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
                </div>
            </div>
            <el-row :gutter="40" style="margin-top: 40px;">
                <el-col :span="9">
<!--                    <div class="btn-box flex justify-between">-->
<!--                        <span :class="timeType == 1 ? 'btn active ' : 'btn'" @click="selectTime(1)">今日</span>-->
<!--                        <span :class="timeType == 2 ? 'btn active ' : 'btn'" @click="selectTime(2)">本周</span>-->
<!--                        <span :class="timeType == 3 ? 'btn active ' : 'btn'" @click="selectTime(3)">本月</span>-->
<!--                        <span :class="timeType == 4 ? 'btn active ' : 'btn'" @click="selectTime(4)">本季度</span>-->
<!--                        <span :class="timeType == 5 ? 'btn active ' : 'btn'" @click="selectTime(5)">本年</span>-->
<!--                    </div>-->
                    <el-row class="btn-box" :gutter="20">
                      <el-col :span="5">
                        <div :class="timeType == 1 ? 'btn active ' : 'btn'" @click="selectTime(1)">今日</div>
                      </el-col>
                      <el-col :span="5">
                        <div :class="timeType == 2 ? 'btn active ' : 'btn'" @click="selectTime(2)">本周</div>
                      </el-col>
                      <el-col :span="5">
                        <div :class="timeType == 3 ? 'btn active ' : 'btn'" @click="selectTime(3)">本月</div>
                      </el-col>
                      <el-col :span="5">
                        <div :class="timeType == 4 ? 'btn active ' : 'btn'" @click="selectTime(4)">本季度</div>
                      </el-col>
                      <el-col :span="4">
                        <div :class="timeType == 5 ? 'btn active ' : 'btn'" @click="selectTime(5)">本年</div>
                      </el-col>

                    </el-row>
                    <div class="container-left">
                        <div class=" card-box flex flex-column" v-for="(item, index) in productData" :key="index">
                            <span>{{ item.title }}</span>
                            <span>{{ item.count }}</span>
                            <span>昨日{{ item.yesterdayCount }}</span>
                        </div>
                    </div>
                </el-col>
                <el-col :span="15" align="right">
                    <div class="visitor-container" style="margin: 0;padding: 0;">
                        <div class="container-right" id="lineChart">

                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- 订单数据统计 -->
        <div class="card-container">
            <div class="title-container flex">
                <span class="title">订单数据统计
                </span>
            </div>
            <div class="order-container flex ">
                <div class="order-item flex flex-column" v-for="(item, index) in orderData" :key="index">
                    <div class="flex align-center justify-center icon-box">
                        <el-image v-if="item.icon" :src="item.icon" fit="fill" class="order-icon" />
                        <span>{{ item.title }}</span>
                    </div>
                    <div class="order-num">{{ item.count }}</div>
                </div>
            </div>
        </div>
        <!-- 今日访客记录 -->
        <div >
            <el-row :gutter="20" style="margin-top: 10px;">
                <el-col :span="8">
                    <div class="visitor-container">
                        <span class="title">今日访客记录
                        </span>
                        <div class="visitor-top flex align-start flex-column">
                            <span>新增访客(人)</span>
                            <span class="visitor-num" style="color: red;">{{ record.newVisitor }}</span>
                        </div>
                        <div class="flex justify-between" style="width: 290px;">
                            <div class="visitor-top flex align-start flex-column">
                                <span>当日浏览量
                                </span>
                                <span class="visitor-num">{{ record.todayView }}</span>
                            </div>
                            <div class="visitor-top flex align-start flex-column">
                                <span>总访客(人)
                                </span>
                                <span class="visitor-num">{{ record.allVisitor }}</span>
                            </div>
                        </div>
                    </div>

                </el-col>
                <el-col :span="16">
                    <div class="visitor-container">
                        <span class="title">财务统计
                        </span>
                        <div style="width: 80%;height: 300px;margin: auto;" id="barChart"></div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>

export default {
  name: '',
  data () {
    return {
      iconList1: [
        require('@/assets/images/data_report/icon-data01.png'),
        require('@/assets/images/data_report/icon-data02.png'),
        require('@/assets/images/data_report/icon-data03.png'),
        require('@/assets/images/data_report/icon-data04.png'),
        require('@/assets/images/data_report/icon-data05.png'),
        require('@/assets/images/data_report/icon-data06.png')

      ],
      cardData: [],
      productData: [
      ],
      iconList2: [
        require('@/assets/images/data_report/icon-data1.png'),
        require('@/assets/images/data_report/icon-data2.png'),
        require('@/assets/images/data_report/icon-data3.png'),
        require('@/assets/images/data_report/icon-data4.png'),
        require('@/assets/images/data_report/icon-data5.png')
      ],
      orderData: [],
      dateTime: null, // 商品统计 日期
      // 更新时间
      updateTime: null,
      record: {},
      timeType: 1
    }
  },
  watch: {
    dateTime (val) {
      console.log(val)
      this.updateTime = this.$moment().format('YYYY-MM-DD HH:mm:ss')
      this.initLineChart()
    }
  },

  mounted () {
    this.getData()
    this.initLineChart()
    this.initBarChart()
  },
  created () {
    this.updateTime = this.$moment().format('YYYY-MM-DD HH:mm:ss')
  },
  methods: {
    selectTime (type) {
      this.timeType = type
      this.getDataModule2()
    },
    getData () {
      this.$http.all([
        this.$http.post('/dataReport/dataReportModule1'),
        this.$http.post('/dataReport/dataReportModule3'),
        this.$http.post('/dataReport/dataReportModule4')

      ]).then(this.$http.spread((res1, res3, res4) => {
        if (res1.data.code == 200) {
          let list = res1.data.data
          list.forEach((item, index) => {
            let e = {
              title: item.title,
              count: item.amount || '0',
              icon: this.iconList1[index]
            }
            if (index >= 2) {
              e.count = '￥' + e.count
            }
            this.cardData.push(e)
          })
        }

        if (res3.data.code == 200) {
          let list = res3.data.data
          list.forEach((item, index) => {
            let e = {
              title: item.title,
              count: item.amount || '0',
              icon: this.iconList2[index]
            }
            this.orderData.push(e)
          })
        }
        if (res4.data.code == 200) {
          this.record = res4.data.data
        }
      }))
      this.getDataModule2()
    },
    async getDataModule2 () {
      let res = await this.$http.post('/dataReport/dataReportModule2', {
        flag: this.timeType
      })
      if (res.data.code == 200) {
        let list = res.data.data
        this.productData = []
        list.forEach(item => {
          let e = {
            title: item.title,
            count: item.count || '0',
            yesterdayCount: item.yesterdayCount || '0'
          }
          this.productData.push(e)
        })
      }
    },
    // 初始化折线图 商品数据统计
    async initLineChart () {
      let startTime = null
      let endTime = null
      if (this.dateTime) {
        startTime = this.dateTime[0]
        endTime = this.dateTime[1]
      }
      let xAxis = []
      let series1 = []
      let series2 = []
      let res = await this.$http.post('/dataReport/dataReportChart1', {
        startTime: startTime,
        endTime: endTime
      })
      if (res.data.code == 200) {
        xAxis = res.data.data.xList
        series1 = res.data.data.y1List
        series2 = res.data.data.y2List
      }

      let lineChart = this.$echarts.init(document.getElementById('lineChart'))
      let option = {
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(76, 75, 75, 0.73)',
          textStyle: {
            color: '#FFF'
          }
        },

        /*  dataZoom: [
                     {
                         type: 'inside',
                         start: 0,
                         end: 100
                     },
                     {
                         start: 0,
                         end: 100
                     }
                 ], */
        grid: {
          left: '1%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },

        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xAxis
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '交易量',
            type: 'line',
            stack: 'Total',
            symbolSize: 12, // 设置圆圈的大小为10
            symbol: 'circle', // 将小圆点改成实心 不写symbol默认空心
            // 设置折线颜色
            itemStyle: {
              normal: {
                color: '#0C67F5', // 圆心颜色
                lineStyle: {
                  color: '#0C67F5' // 线的颜色
                }
              }
            },
            label: {
              show: true, // 显示标签
              position: 'top', // 标签位置，对于直线图，通常设置为 'top'
              formatter: '{c}' // 标签内容格式器，'{c}' 代表数据值
            },
            data: series2
          },
          {
            name: '交易额',
            symbolSize: 12, // 设置圆圈的大小为10
            type: 'line',
            stack: 'Total',
            symbol: 'circle', // 将小圆点改成实心 不写symbol默认空心
            // 设置折线颜色
            itemStyle: {
              normal: {
                color: '#FD7C25', // 圆心颜色
                lineStyle: {
                  color: '#FD7C25' // 线的颜色
                }
              }
            },
            label: {
              show: true, // 显示标签
              position: 'top', // 标签位置，对于直线图，通常设置为 'top'
              formatter: '{c}' // 标签内容格式器，'{c}' 代表数据值
            },
            data: series1
          }

        ]
      }
      lineChart.setOption(option)
      window.addEventListener('resize', () => {
        lineChart.resize()
      })
    },
    // 初始化柱状图
    async initBarChart () {
      let xAxis = []
      let series = []
      let res = await this.$http.post('/dataReport/dataReportChart2')
      if (res.data.code == 200) {
        xAxis = res.data.data.xList
        series = res.data.data.y1List
      }
      let barChart = this.$echarts.init(document.getElementById('barChart'))
      let option = {
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(76, 75, 75, 0.73)',
          textStyle: {
            color: '#FFF'
          },
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: xAxis,
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: '',
            type: 'bar',
            barWidth: '60%',
            itemStyle: {
              color: '#5B8FF9'
            },
            data: series,
            label: {
              show: true, // 显示标签
              position: 'top' // 标签的位置，可以是 'top', 'bottom', 'left', 'right', 'inside', 'insideTop', 'insideBottom', 'insideLeft', 'insideRight', 'insideTopLeft', 'insideBottomLeft', 'insideTopRight', 'insideBottomRight'
            }
          }
        ]
      }
      barChart.setOption(option)
      window.addEventListener('resize', () => {
        barChart.resize()
      })
    }
  }
}
</script>

<style scoped lang="less">
.panel-group {
    //margin: 10px 0;
    box-sizing: border-box;
    display: flex;

    justify-content: space-between;

    .card-panel {
        width: 178px;
        background: #fff;
        box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.05);
        align-items: center;
        justify-content: space-around;
        padding: 20px;
        margin-bottom: 10px;
        margin-right: 10px;

        .card-panel-icon-wrapper {
            width: 70px;
            height: 70px;
            border-radius: 50px;
            display: flex;
            align-items: center;
            justify-content: center;

            .icon {
                width: 100%;
                height: 100%;
                border-radius: 50%;
            }
        }

        .card-panel-description {

            .card-panel-text {
                color: #838383;
                font-size: 14px;
                margin-top: 6px;
            }

            .card-panel-num {
                color: #333;
                font-size: 16px;
            }
        }

    }
}

.card-container {
    background-color: #FFF;
    //margin-top: 20px;
    padding: 20px 10px;

    .title-container {
        align-items: center;
        justify-content: space-between;

        .title {
            font-weight: bold;
            color: rgba(51, 51, 51, 1);
            font-size: 18px;
            margin-right: 20px;

        }

        .time {
            color: rgba(118, 118, 118, 1);
            font-size: 16px;
        }
    }

    .container-left {
        margin-top: 40px;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        /* 3列，每列宽度相等 */
        grid-template-rows: repeat(2, 1fr);
        /* 2行，每行高度相等 */
        gap: 10px;

        .card-box {

            width: 150px;
            height: 140px;
            border-radius: 5px;
            background-color: rgba(251, 251, 251, 1);
            color: rgba(51, 51, 51, 1);
            font-size: 16px;
            justify-content: center;
            align-items: center;

            :nth-child(1) {
                font-size: 10px;
                color: #838383;
                margin: 10px auto;
            }

            :nth-child(2) {
                font-size: 16px;
                color: #333;
                font-weight: bold;
            }

            :nth-child(3) {
                font-size: 10px;
                color: #838383;
                margin: 10px auto;
            }
        }
    }

    .container-right {
        width: 80%;
        height: 360px;
        margin: auto;
    }

    .order-container {
        justify-content: space-between;
        align-items: center;
        margin-top: 20px;

        .order-item {
            flex: 1 0 20%;
            /* 每个元素占据33.333%的宽度 */
            justify-content: space-between;
            align-items: center;

            .order-num {
                margin-top: 20px;
                font-size: 24px;
                color: #333;
                font-weight: bold;
            }

            .icon-box {
                display: flex;
                align-items: center;

                .order-icon {
                    width: 25px;
                    height: 25px;
                    margin-right: 10px;
                }

            }
        }
    }
}

.visitor-container {
    margin-top: 10px;
    padding: 20px 10px;
    background-color: #FFF;
    height: 340px;

    .title {
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        font-size: 18px;
        margin-right: 20px;

    }

    .visitor-top {
        margin-top: 50px;
        margin-left: 40px;
        color: #333;
    }

    .visitor-num {

        margin-top: 20px;
        font-weight: bold;
        font-size: 24px;
    }

}

.btn-box {
    width: 460px;
    margin-top: 20px;
    margin-left: 10px;


    .btn {

        width: 80px;
        height: 30px;
        line-height: 30px;
        border-radius: 5px;
        background-color: rgba(255, 255, 255, 1);
        color: rgba(2, 2, 2, 1);
        font-size: 15px;
        text-align: center;
        font-family: Arial-regular;
        border: 1px solid rgba(121, 121, 121, 0.15);
        cursor: pointer;
    }

    .active {

        background-color: rgba(64, 158, 255, 1);
        color: rgba(255, 255, 255, 1);

    }

}
</style>
